import React from 'react';
import PanelContainer from '@/components/wrappers/PanelContainer';
import fetch from '../hooks/fetch';

const UserGroupPanelContainerGuarded = ({
  canRead,
  category,
  children,
  code,
  description,
  fetchGroup,
  isDirty,
  isDuplicate,
  isNew,
  name,
  newGroup,
  onChange,
  readErrors,
  readStatus,
  url,
}) => {
  fetch.useFetchOrNewUserGroup(fetchGroup, newGroup, category, code, readStatus, url, isNew, isDuplicate);
  return (
    <PanelContainer
      canAccess={canRead}
      description={description}
      entity="usergroup"
      exists
      isDirty={isDirty}
      isNew={isNew}
      name={name}
      onChange={onChange}
      readErrors={readErrors}
      readStatus={[readStatus]}
      url={url}
    >
      {children}
    </PanelContainer>
  );
};

export default UserGroupPanelContainerGuarded;
